import React from "react";
import "./AllReviews.scss";
import ReviewsAverage from "../../../components/ReviewsAverage/ReviewsAverage";
import BookingHeader from "../../../components/BookingHeader/BookingHeader";
import SingleReview from "../../../components/SingleReview/SingleReview";

const AllReviews = ({ widgetInfo, handleNavBack }) => {
  return (
    <div className="AllReviews">
      <BookingHeader reviews onBack={handleNavBack} />
      <div className="reviewsWrapper">
        <ReviewsAverage
          rating={widgetInfo.company.average_rating}
          reviewsLen={widgetInfo.company.reviews.length}
          grades={widgetInfo.company.rating_grades}
        />
        {widgetInfo.company.reviews.map((review) => (
          <SingleReview review={review} />
        ))}
      </div>
    </div>
  );
};

export default AllReviews;
